/* -----------------------------------------------------------------------------
 * Wizard SM State
 *
 * @description - State of Wizard SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

import routes from '@/router/routes'
import { parseSteps } from '@/utils/wizard'

export default {

  steps: parseSteps(routes), // steps as array of ASC sorted routes objects
  stepIdx: 0, // current step index
  routeName: '', // current route name
  routeStepIdx: -1, // if current route is not step => -1 || 0, 1, 2...
  lockStepSwitch: true, // steps switching locker
  view: null, // current view component vm

  // Navigation
  navigation: {
    loadingPrev: false,
    loadingNext: false,
    disablePrev: false,
    disableNext: false,
    errorTextPrev: '',
    errorTextNext: ''
  }

}
